<template>
  <div>
    
    <div 
      v-if="debugStore.showUi" 
      class=" w-full h-screen fixed top-0 left-0 overflow-y-hidden"
      style="z-index: 1000;"
    >
      <div class=" mx-0 sm:mx-auto sm:max-w-md h-full p-5 overflow-auto relative bg-yellow-200">
      <!-- <div v-if="debugStore.isDebug" class="bg-yellow-400">{{ debugStore.data }}</div> -->

        <div class="absolute top-5 right-5">
          <button @click="closeDebugUI" class="text-red-500 text-4xl">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="mb-2">
          <p class="text-lg mb-2 font-bold">ข้อมูล Debug</p>
          <p>Event ID : {{debugStore.data?.eventId}}</p>
        </div>

        <!-- user images -->
        <div class="mb-5 pb-5 border border-white p-3 rounded-lg bg-white">
          <p>My Image
            <span v-if="!debugStore.data.myImageUrl">-</span>
          </p>

          <div class="p-3 space-y-2">
            <p>Original Image</p>
            <div class="bg-gray-300 rounded-lg">
              <img :src="debugStore.data.myImageUrl"/>
            </div>

            <p>Remove BG Image</p>
            <div class="bg-gray-300 rounded-lg">
              <img :src="debugStore.data.myImageRemovebgUrl"/>
            </div>
          </div>
        </div>

        <!-- templates -->
        <div class="mb-5 space-y-5">
          <div class="border border-white p-3 rounded-lg bg-white">
            <p>Template 1 : {{ debugStore.data.template1?.templateId }}</p>
            <div class="bg-gray-300" v-if="debugStore.data.template1?.bgImageUrl">
              <img :src="debugStore.data.template1.bgImageUrl"/>
            </div>
          </div>

          <div class="border border-white p-3 rounded-lg bg-white">
            <p>Template 2 : {{ debugStore.data.template2?.templateId }}</p>
            <div class="bg-gray-300" v-if="debugStore.data.template2?.bgImageUrl">
              <img :src="debugStore.data.template2.bgImageUrl"/>
            </div>
          </div>

          <div class="border border-white p-3 rounded-lg bg-white">
            <p>Template 3 : {{ debugStore.data.template3?.templateId }}</p>
            <div class="bg-gray-300" v-if="debugStore.data.template3?.bgImageUrl">
              <img :src="debugStore.data.template3.bgImageUrl"/>
            </div>
          </div>
        </div>


        
      </div>
    </div>


    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

  </div>
</template>


<script lang="ts" setup>
  import { useAuthStore } from './store/auth'
  import { useEventStore } from './store/event'
  import { useAppStateStore } from './store/appState'
  import { useTemplateStore } from './store/template'
  import { useWishStore } from './store/wish'
  import { usePromptpay } from './store/promptpay'
  import { useRestorePageStore } from './store/restorePage'
  import { useAppVersionStore } from './store/appVersion'
import { useDebugStore } from './store/debug'

  const $route = useRoute()
  const $router = useRouter()

  const authStore = useAuthStore()
  const appStateStore = useAppStateStore()
  const eventStore = useEventStore()
  const templateStore = useTemplateStore()
  const wishStore = useWishStore()
  const promptpayStore = usePromptpay()
  const restorePage = useRestorePageStore()
  const appVersion = useAppVersionStore()
  const debugStore = useDebugStore()

  onMounted(() => {
    appStateStore.vConsoleInstance =  new window.VConsole();
    appStateStore.vConsoleInstance?.hideSwitch()
  })


  onMounted(async () => {
    await authStore.main()
    const isSuccess = await eventStore.main()
    if(isSuccess) {
      await Promise.all([
        wishStore.main(),
        appStateStore.main(),
        promptpayStore.main(),
        eventStore.getEventTracking(),
        eventStore.getEventTrackingToday(),
       // restorePage.getRestorePage() // not used
      ])

      await eventStore.getEventUserTracking(),
      await templateStore.main()
      await appVersion.main()
      await debugStore.main()
    } 
  })

  const closeDebugUI = () => {
    debugStore.showUi = false
  }
</script>


